import { Injectable } from '@angular/core';
import {Http, RequestOptions,  } from '@angular/http';
import {  HttpErrorResponse } from '@angular/common/http';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import {Login, LoginStatus, SignupStatus} from '../modules/login';
import {Observer} from 'rxjs/Observer';
import {Headers} from '@angular/http';
import {Router} from '@angular/router';
import {Cookie} from 'ng2-cookies';
import {User} from '../modules/user';

import { catchError } from 'rxjs/operators';
import {Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent, throwError} from 'rxjs';


@Injectable()
export class AuthService {
  //isLoggedIn: Observable<boolean>;
  isLoginSubject = new BehaviorSubject<boolean>(this.hasToken());
  private observer: Observer<boolean>;

  user = {name: 'Guest'};
  redirectUrl: string;
  serverUrl = 'http://localhost:8080';
  headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: Http, private router: Router) {
    // this.isLoggedIn = new Observable(observer =>
    //   this.observer = observer
    // );
  }

  isLoggedIn(): Observable<boolean> {
    return this.isLoginSubject.asObservable();
  }

  // checkLoginStatus(): Observable<boolean> {
  //   return this.isLoggedIn;
  // }

  signup(newUser: User): Promise<SignupStatus> {
    const url = `${this.serverUrl}/account/signup`;
    const options       = new RequestOptions({ headers: this.headers });

    return this.http.post(url, newUser, options)
      .toPromise()
      .then(res => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }


  // getAllMenuItems(): Observable<any> {
  //   return this.http
  //     .get(  '/ext_api/ios/app/get')
  //     .map(response => {
  //       const todos = response.json();
  //       return todos.map();
  //     })
  //     .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  // }

  login(login: Login): Observable<LoginStatus> {
      //console.log('username:' + login.email );
      //console.log('password:' + login.password );
    let params = new URLSearchParams();
    params.append('username', login.email);
    params.append('password', login.password);
    params.append('grant_type', 'password');
    params.append('client_id', 'tv6app');
    let headers = new Headers({'Content-type': 'application/x-www-form-urlencoded; charset=utf-8', 'Authorization': 'Basic ' + btoa('tv6app:HeAltH@!23')});
    let options = new RequestOptions({ headers: headers });

    return this.http.post('/oauth/token', params.toString(), options)
      .map(res => {
        let token: any = res.json();
        //console.log('isPortal res.json():' + token.isPortal );
        //console.log('access_token res.json():' + token.access_token );
        //const data = JSON.parse(res.toString());
        //console.log('res.json():' + res.toString() );
        //console.log('res.json():' + JSON.stringify(res.json()) );
        //  if ( !res.json().isPortal) {
        // //   //return Observable.of(new LoginStatus('FAILURE', 'Username or password is incorrect. Please try again!'));
        //     return new LoginStatus('FAILURE', 'This user is not allowing at web portal');
        //  }
        //
        localStorage.setItem('token', 'JWT');
          localStorage.setItem('isLoggedin', 'true');
        this.isLoginSubject.next(true);
          localStorage.setItem('username', login.email);
        Cookie.set('username', login.email);
        this.saveToken(res.json());
        return new LoginStatus('SUCCESS', 'Login Successful');
      })
      .catch((error: any) => {
        return Observable.of(new LoginStatus('FAILURE', 'Username or password is incorrect. Please try again!'));
      });
  }

  saveToken(token: any) {
    let expireDate = new Date().getTime() + (1000 * token.expires_in);
    Cookie.set('access_token', token.access_token, expireDate);
    Cookie.set('role', token.role);
//    console.log('access_token:' + token.access_token );
    console.log('role:' + token.role );
    this.changeLoginStatus(true);
//    if (token.role === 'ROLE_DOCTOR') {
//      this.router.navigate(['rx']);
//    } else {
//      this.router.navigate(['patient/home']);
//    }

  }

  checkCredentials() {
    if (!Cookie.check('access_token')) {
      this.router.navigate(['/login']);
    }
  }

  logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
    localStorage.removeItem('token');
    this.isLoginSubject.next(false);
    Cookie.delete('access_token');
    Cookie.delete('role');
//    this.changeLoginStatus(false);
  }

  changeLoginStatus(status: boolean) {
    if (this.observer !== undefined) {
      this.observer.next(status);
    }
  }

  private hasToken(): boolean {
    return !!localStorage.getItem('token');
  }

  token(): void {
    const url = `${this.serverUrl}/account/token`;
    const options       = new RequestOptions({ headers: this.headers, withCredentials: true });

    this.http.get(url, options)
      .toPromise()
      .then(response => {
      })
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

    errorHandler(error: HttpErrorResponse) {
        //return throwError(error.message || "Server Error")
        if (error.status === 401) {
            console.log( '  errorHandler:' + 401);
            //this.authService.logout();
            //this.router.navigate(['/login']);
        }
        return Observable.throw(error || 'Server error');
    }
}
